<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col class="py-0">
                    <v-text-field v-model="projectionName" :label="language.t('ProjectDetails.name')" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row>
                <v-col class="py-1" cols="4">
                    PROJECTION
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.lat_0" label="lat_0" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.lon_0" label="lon_0" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.y_0" label="y_0" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.x_0" label="x_0" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.k_0" label="k_0" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-1" cols="4">
                    LOC ELLIPSOID
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.a" label="a" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="projectionParameters.rf" label="rf" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

            </v-row>
            <v-row>
                <v-col class="py-1" cols="4">
                    HORZ ADJUST
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_px" label="tyker_px" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_py" label="tyker_py" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_x" label="tyker_x" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_y" label="tyker_y" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_rz" label="tyker_rz" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field v-model="tykerParameters.tyker_s" label="tyker_s" required dense
                        :rules="siteCalibrationRules"></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
export default {
    components: {
    },
    props: { projectionName: null },
    data() {
        return {
            projectionParameters: {
                proj: null,
                lat_0: null,
                lon_0: null,
                k_0: null,
                x_0: null,
                y_0: null,
                a: null,
                rf: null,
            },
            tykerParameters: {
                tyker_x: null,
                tyker_px: null,
                tyker_y: null,
                tyker_py: null,
                tyker_s: null,
                tyker_rz: null,
            },
            siteCalibrationRules: [(v) => (!!v && !isNaN(v)) || "valid value required"],
        };
    },
    mounted: function () {
    },
    computed: {},
    watch: {
    },
    methods: {
    },
};
</script>